import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { LockOverlayVariant } from '../../../enums/lock-overlay-variant';
import { T } from 'src/assets/i18n/translation-keys';

@Component({
    selector: 'app-lock-overlay',
    templateUrl: './lock-overlay.component.html',
    styleUrls: ['./lock-overlay.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LockOverlayComponent {
  @Input() show: boolean = false;
  @Input() variant: LockOverlayVariant = LockOverlayVariant.Card;

  public readonly LockOverlayVariant = LockOverlayVariant;
  public readonly T = T;

  public preventClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }
}
